import request from "@/utils/request";

// 拿微信票据
export function getDatas(params) {
  return request({
    url: "/wechat/wechat/getJsTicket",
    method: "get",
    params
  });
}

// 拿oppenID和用户信息
export function getOpenIdAndUser(params) {
  return request({
    url: "/wechat/wechat/getUserInfo",
    method: "get",
    params
  });
}
// 获取家人信息列表
export function getFamilyInfoList(params) {
  return request({
    url: "/wechat/weixin/userInfo/list",
    method: "get",
    params
  });
}
// 完善个人信息
export function setUserInfo(data) {
  return request({
    url: "/wechat/weixin/userInfo/addOwnInfo",
    method: "POST",
    data
  });
}
// 添加家人
export function addFamily(data) {
  return request({
    url: "/wechat/weixin/userInfo/addFamliyInfo",
    method: "POST",
    data
  });
}
// 修改家人信息
export function setFamilyInfo(data) {
  return request({
    url: "/wechat/weixin/userInfo/update",
    method: "PUT",
    data
  });
}
// 获取本人信息详情
export function getUserInfoDetail(openId) {
  return request({
    url: `/wechat/weixin/userInfo/viewOwnInfo/${openId}`,
    method: "get"
  });
}
// 查看是否完善用户信息
export function getIsComplateUserInfo(params) {
  return request({
    url: `/wechat/weixin/apply/checkUserInfo`,
    method: "get",
    params
  });
}
//获取所属区域下拉框内容
export function getDistrictSelect(params) {
  return request({
    url: `/wechat/base/area/config`,
    method: "get",
    params
  });
}
//获取与本人关系下拉框内容
export function getRelationSelect() {
  return request({
    url: `/wechat/system/dict/datas`,
    method: "get",
    params: { dictTypes: ["my_relation"] }
  });
}
//获取信息详情
export function getPersonInfo(id) {
  return request({
    url: `/wechat/weixin/userInfo/detail/${id}`,
    method: "get"
  });
}

//获取验证码
export function getSmsLogin(params) {
  return request({
    url: `/wechat/weixin/userInfo/smsLogin`,
    method: "post",
    params
  });
}

//获取验证码
export function login(params) {
  return request({
    url: `/wechat/weixin/userInfo/smsLogin/login`,
    method: "post",
    params
  });
}

